export default class Cookie {
    banner;
    title;
    message;
    cta;
    template;

    constructor(options = {}) {
      console.log(php_vars.php_lang)
      var str_title, str_message, str_cta;
      if(php_vars.php_lang=='en'){
        str_title = 'Cookie policy';
        str_message = 'This website uses cookies. By continuing to browse the website, you are agreeing to our <a href="http://zeusisloose.optimus-prime.gr/privacy-policy/">cookies policy</a>.';
        str_cta = 'I agree';
      }else if(php_vars.php_lang =='el'){
        str_title = "Πολιτική cookie" ;
        str_message = "Αυτός ο ιστότοπος χρησιμοποιεί cookies. Συνεχίζοντας την περιήγηση στον ιστότοπο, αποδέχεστε την <a href='http://zeusisloose.optimus-prime.gr/privacy-policy/'>πολιτική μας</a>. ";
        str_cta = "Συμφωνώ"
      }
        this.title = options.title || str_title;
        this.message = options.message || str_message;
        this.cta = options.cta || str_cta;
        this.template = options.template ||
			`<div class="sw-cookie-banner">
				<div class="sw-cookie-header">
					<h3 class="sw-cookie-title"></h3>
					<button class="sw-cookie-close"><span class="sr-only">Dismiss</span></button>
				</div>
				<p class="sw-cookie-message"></p>
				<div class="sw-cookie-footer">
					<button class="sw-cookie-cta"></button>
				</div>
			</div>`;

        if (!this.hasCookie()) {
            this.initBanner();
        }

    }

    initBanner() {
        this.banner = document.createElement('div');
        this.banner.classList.add('sw-cookie');
        this.banner.innerHTML = this.template;
        const title = this.banner.querySelector('.sw-cookie-title');
        if (title) {
            title.innerHTML = this.title;
        }
        const message = this.banner.querySelector('.sw-cookie-message');
        if (message) {
            message.innerHTML = this.message;
        }
        const cta = this.banner.querySelector('.sw-cookie-cta');
        if (cta) {
            cta.innerHTML = this.cta;
            cta.addEventListener('click', () => this.dismiss(true))
        }
        const close = this.banner.querySelector('.sw-cookie-close');
        if (close) {
            close.addEventListener('click', () => this.dismiss())
        }
        document.body.append(this.banner);

    }

    dismiss(accepted = false) {
        this.banner.style.transform = 'translateY(20px)';
        this.banner.style.opacity = '0';
        if (accepted) {
            this.setCookie('cookiesareloose', 'true', 30);
		}
		requestTimeout(() =>{
			this.banner.remove();
		}, 500)
    }

    hasCookie() {
        return this.getCookie("cookiesareloose") === "true";
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }


}